module.exports = "/build/web/images/header-academy.40b0978c868ee99a50e29c8f3f57c0e6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./images/header-academy.jpeg
// module id = 124
// module chunks = 24